import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../lib/cn.js';
const VARIANT = {
    default: 'border-[var(--border)]',
    focus: 'border-[var(--border-strong)]',
};
export const Card = forwardRef(function Card({ variant = 'default', as: As = 'article', className, ...rest }, ref) {
    return (_jsx(As, { ref: ref, className: cn('bg-[var(--surface)] border rounded-[var(--radius-card)] p-[18px]', VARIANT[variant], className), ...rest }));
});
export const CardHeader = forwardRef(function CardHeader({ className, ...rest }, ref) {
    return (_jsx("div", { ref: ref, className: cn('flex items-center justify-between gap-[14px]', className), ...rest }));
});
export const CardEyebrow = forwardRef(function CardEyebrow({ className, ...rest }, ref) {
    return _jsx("p", { ref: ref, className: cn('text-[var(--text-muted)] m-0', className), ...rest });
});
export const CardTitle = forwardRef(function CardTitle({ className, ...rest }, ref) {
    return (_jsx("h2", { ref: ref, className: cn('text-[24px] leading-[1.05] font-extrabold m-0 text-[var(--text)]', className), ...rest }));
});
export const CardContent = forwardRef(function CardContent({ className, ...rest }, ref) {
    return _jsx("div", { ref: ref, className: cn('mt-4', className), ...rest });
});
//# sourceMappingURL=Card.js.map